
import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-health',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `<div style="background-color:gray;min-height:20in">
                  Data Bet is Healthy : {{dateTime}}
            </div>`
})
export class HealthComponent {
  isHealth = false;
  dateTime = new Date();

  ngOnInit(): void {
    this.isHealth = window.location.href.includes('/health');
  }
}
